import React from 'react';
import { Spin } from 'antd';
export default () => {
	return (
		<div
			className="Loader"
			style={{
				width: '100%',
				height: '100vh',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			<Spin />
		</div>
	);
};
